import { render, staticRenderFns } from "./TabBeneficiarioControlador.vue?vue&type=template&id=332a0df8&scoped=true"
import script from "./TabBeneficiarioControlador.vue?vue&type=script&lang=js"
export * from "./TabBeneficiarioControlador.vue?vue&type=script&lang=js"
import style0 from "./TabBeneficiarioControlador.vue?vue&type=style&index=0&id=332a0df8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a0df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332a0df8')) {
      api.createRecord('332a0df8', component.options)
    } else {
      api.reload('332a0df8', component.options)
    }
    module.hot.accept("./TabBeneficiarioControlador.vue?vue&type=template&id=332a0df8&scoped=true", function () {
      api.rerender('332a0df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabBeneficiarioControlador.vue"
export default component.exports